module.exports = __webpack_public_path__ + "static/banner-tablet-048568636a8eee441e13bc3f635e89dc.png";